<!-- <div class="timer-auction">
  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value" [strokeWidth]="90"
    [strokeWidth]="strokeWidth">
  </mat-progress-spinner>
  <div class="counter_value">
    <span>{{currentTimer|number:'1.0-0'}}</span>
  </div>

</div> -->

<div style="max-width: 100%;max-height: 100%;">
  <circle-progress [percent]="currentPercent" [title]="countDown" subtitleColor="#1E1346" [outerStrokeWidth]="5"
    [innerStrokeWidth]="0" outerStrokeColor="#FF6B6B" innerStrokeColor="#C7E596" [animationDuration]='0'
    backgroundStroke='#FFE4E4' [backgroundStrokeWidth]="5" [backgroundPadding]="0" [responsive]="true"
     [showUnits]='false' titleFontSize='40' titleFontWeight='700' titleColor="#F53649"
    subtitleFontSize="0" subtitleFontWeight='0'></circle-progress>
</div>
